import { Box, Button, ButtonGroup } from '@mui/material';
import { ReactElement, useState } from 'react';
import NotificationList from './NotificationList';
import NotificationSetting from './NotificationSetting';
import { INotifications } from 'modules/Layout';

const NotificationCenter = (): ReactElement => {
  const [type, setType] = useState('inbox');
  const [selectedNote, setSelectedNote] = useState<INotifications>();

  // UI Elements
  return (
    <Box className="mx-10 notification-list mb-5">
      <ButtonGroup className="app-group-button mt-5 mb-2">
        <Button
          className={type === 'inbox' ? 'primary-light-fill' : ''}
          onClick={() => setType('inbox')}
          variant={type === 'inbox' ? 'contained' : 'text'}
        >
          Inbox
        </Button>
        <Button
          className={type === 'settings' ? 'primary-light-fill' : ''}
          onClick={() => {
            setType('settings');
            setSelectedNote(undefined);
          }}
          variant={type === 'settings' ? 'contained' : 'text'}
        >
          Settings
        </Button>
      </ButtonGroup>

      {type === 'inbox' && (
        <NotificationList
          setType={setType}
          setSelectedNote={setSelectedNote}
          selectedNote={selectedNote}
        />
      )}
      {type === 'settings' && (
        <NotificationSetting selectedNote={selectedNote} />
      )}
    </Box>
  );
};
export default NotificationCenter;
